<template>
  <div class="cell-new-dialog">
    <vs-popup
      class="pm-popup cell-renderer-new-popup"
      title="オーダー新規作成"
      :active="popupActive"
      @close="onClose"
    >
      <div class="flex flex-col gap-5">
        <div class="form-area flex flex-col gap-4">
          <vs-checkbox
            class="ml-0"
            color="#48a0f4"
            v-model="isSelectedFromVesselList"
          >
            船舶管理に登録した船舶から選ぶ
          </vs-checkbox>
          <div class="form-vessel flex items-center gap-6">
            <div class="header font-bold flex-shrink-0">船舶</div>
            <v-select
              v-show="isSelectedFromVesselList"
              class="display-items-select-box flex-grow"
              v-model="selectedVessel"
              :options="vesselOptions"
              label="label"
              placeholder="選択してください"
              :clearable="false"
              :searchable="false"
            >
              <template #selected-option="{}">
                <div style="display: flex; align-items: baseline">
                  {{ selectedVesselName }}
                </div>
              </template>
              <template v-slot:no-options>
                <div>選択可能な船舶がありません</div>
              </template>
            </v-select>

            <vs-input
              v-show="!isSelectedFromVesselList"
              class="input-task-vessel-name flex-grow"
              v-model="vesselName"
              :danger="!isValidVesselName"
              placeholder="船舶名を入力してください"
              color="#626262"
            />
          </div>
          <div class="time-input-area flex items-center">
            <div class="header font-bold flex-shrink-0">時刻</div>
            <div class="flex items-center flex-grow">
              <vs-input-number
                placeholder="時間を入力してください"
                v-model.number="orderHours"
                class="time-input"
                :min="0"
                :max="23"
              />:
              <vs-input-number
                placeholder="分を入力してください"
                v-model.number="orderMinutes"
                class="time-input"
                :min="0"
                :max="59"
              />
            </div>
          </div>
        </div>
        <div class="button-area">
          <vs-button class="popup-button" color="#2E87B9" @click="onCancel"
            >キャンセル</vs-button
          >
          <vs-button
            class="popup-button"
            color="#2E87B9"
            :disabled="!canClickCreate"
            @click="onCreate"
            >新規作成</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import isString from "lodash/isString";
import isObject from "lodash/isObject";
import isNumber from "lodash/isNumber";
import vSelect from "vue-select";
import { createVesselOptions } from "@/utils/gkmgPortMaster";

const EVENTS = {
  CLOSE: "close",
  CANCEL: "cancel",
  CREATE: "create",
};

const INITIAL_STATE = {
  selectedVessel: undefined, // 船舶マスタから選択する場合の選択値
  vesselName: undefined, // 船舶名を入力する場合の入力値
  isSelectedFromVesselList: true, // 船舶マスタから選択するかどうか
  isVesselNameModified: false, // 船舶名が変更されたかどうか
  orderHours: 0, // オーダー時間（時）
  orderMinutes: 0, // オーダー時間（分）
};

/*
 * 入出港予定一覧画面（白色ではなく黒色画面）で、行を新規作成するためのポップアップ
 */

export default {
  name: "NewTaskDialog",
  components: {
    vSelect,
  },
  props: {
    popupActive: { type: Boolean, required: true },
    vesselsData: {
      type: Array, // vesselsData は船舶マスタのデータを想定
      default: () => [],
    },
  },
  data() {
    return {
      ...INITIAL_STATE,
    };
  },
  computed: {
    vesselOptions() {
      const { vesselsData } = this;
      return createVesselOptions(vesselsData);
    },
    selectedVesselName() {
      const { selectedVessel } = this;
      if (!isObject(selectedVessel)) return "";
      return selectedVessel.label || "";
    },
    isValidForm() {
      const {
        isValidSelectedVessel,
        isValidVesselName,
        isValidOrderHours,
        isValidOrderMinutes,
      } = this;

      return (
        isValidSelectedVessel &&
        isValidVesselName & isValidOrderHours & isValidOrderMinutes
      );
    },
    isValidSelectedVessel() {
      const { isSelectedFromVesselList, selectedVessel } = this;
      if (!isSelectedFromVesselList) return true;
      return isObject(selectedVessel) && isString(selectedVessel.id);
    },
    isValidVesselName() {
      const { isVesselNameModified, isSelectedFromVesselList, vesselName } =
        this;
      if (isSelectedFromVesselList) return true;
      if (!isVesselNameModified) return true;
      return isString(vesselName) && vesselName.length > 0;
    },
    isValidOrderHours() {
      const { orderHours } = this;
      if (!isNumber(orderHours)) return false;
      return orderHours >= 0 && orderHours <= 23;
    },
    isValidOrderMinutes() {
      const { orderMinutes } = this;
      if (!isNumber(orderMinutes)) return false;
      return orderMinutes >= 0 && orderMinutes <= 59;
    },
    // 新規作成ボタンを活性条件
    canClickCreate() {
      const { isVesselNameModified, isSelectedFromVesselList, isValidForm } =
        this;
      if (!isSelectedFromVesselList && !isVesselNameModified) {
        return false;
      }
      return isValidForm;
    },
    taskData() {
      const {
        isSelectedFromVesselList,
        selectedVessel = {},
        vesselName,
        orderHours,
        orderMinutes,
      } = this;

      const vesselId = isSelectedFromVesselList ? selectedVessel.id : undefined;
      const _vesselName = isSelectedFromVesselList ? undefined : vesselName;
      const taskData = {
        vesselId,
        vesselName: _vesselName,
        orderHours,
        orderMinutes,
      };
      //   {vesselId: string; vesselName: undefined; orderHours: number; orderMinutes: number}
      // | {vesselId: undefined; vesselName: string; orderHours: number; orderMinutes: number}
      return taskData;
    },
  },
  watch: {
    vesselName() {
      this.isVesselNameModified = true; // 船舶名が変更されていない場合は、validation error を表示しない
    },
    popupActive(active) {
      if (!active) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.resetState(); // ポップアップが閉じられたときに状態をリセット
          }, 200);
        });
      }
    },
    orderHours(val) {
      if (val === "") {
        this.orderHours = 0;
      }
    },
    orderMinutes(val) {
      if (val === "") {
        this.orderMinutes = 0;
      }
    },
  },
  methods: {
    onClose() {
      this.$emit(EVENTS.CLOSE);
    },
    onCancel() {
      this.$emit(EVENTS.CANCEL);
    },
    onCreate() {
      this.$emit(EVENTS.CREATE, this.taskData);
    },
    resetState() {
      Object.keys(INITIAL_STATE).forEach((key) => {
        this[key] = INITIAL_STATE[key];
      });
    },
    onChangeOrderHours(hours) {
      this.orderHours = Number(hours);
    },
    onChangeOrderMinutes(minutes) {
      this.orderMinutes = Number(minutes);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";

.pm-popup {
  user-select: none; /* 選択を禁止する */
  ::v-deep .vs-popup {
    width: 500px;
    background-color: #f0f0f0 !important;
  }
  header {
    h3 {
      text-align: center;
      background-color: $pm-white;
      width: 100%;
      position: relative;
      font-family: "Hiragino Kaku Gothic ProN";
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      align-items: center;
      color: #4f4f4f;
    }

    background-color: $pm-white;
  }

  .vs-popup--close {
    background-color: $pm-white !important;
    transform: translate(-10px, 10px);
    &:hover {
      transform: translate(-10px, 8px);
    }
  }

  .confirm-text {
    text-align: center;
  }
  .popup-button {
    flex: 1;
    font-weight: 600;
    font-size: 16px;
  }
  .button-area {
    padding: 0 14px;
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: center;
    column-gap: 28px;
  }
  .form-area {
    .form-vessel {
      height: 35px; // 船舶名入力時とドロップダウンリスト入力時で高さを合わせる
    }
    // 船舶名編集
    ::v-deep .input-task-vessel-name {
      > * {
        height: 35px;
      }
      .con-text-validation {
        display: none; // バリデーション時のスタイル調整
      }
    }
    .time-input-area {
      ::v-deep .time-input {
        background-color: #f2f2f2;
      }
      ::v-deep .vs-input-number--button-less {
        display: none !important;
      }
      ::v-deep .vs-input-number--button-plus {
        display: none !important;
      }
    }
  }
  ::v-deep div.vs-popup--content {
    overflow: visible; // 船舶ドロップダウンリストをポップアップからはみ出ても表示するため
  }
}
</style>
